import { Link } from 'react-router-dom';

export const ProductBreadcrumb = ({ product, index }) => (
  <div className="pt-28 pb-4">
    <div className="container mx-auto flex items-center justify-between flex-wrap gap-3">
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <Link to="/" className="hover:text-primary">Home</Link>
        <span>/</span>
        <Link to="/products" className="hover:text-primary">Products</Link>
        <span>/</span>
        <span className="text-primary font-medium">{product.name}</span>
      </div>
      <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
        Sheet 0{index + 1} / 08
      </div>
    </div>
  </div>
);

export default ProductBreadcrumb;
